'use strict';
const _ = require('underscore');

var Routes = {
    info: {},
    alias: {}
};

// サーバサイドAPIパスの定義
Routes.info['api:my/blob']        = '/api/my/blobs';
Routes.info['api:notification']   = '/api/my/notifications/{{notification_id}}';
Routes.info['api:groups']         = '/api/groups';
Routes.info['api:group']          = '/api/groups/{{gid}}';
Routes.info['api:group/blob']     = '/api/groups/{{gid}}/blobs';
Routes.info['api:projects']       = '/api/groups/{{gid}}/projects';
Routes.info['api:project']        = '/api/projects/{{pid}}';
Routes.info['api:project:events'] = '/api/projects/{{pid}}/events';
Routes.info['api:milestones']     = '/api/projects/{{pid}}/milestones';
Routes.info['api:milestone']      = '/api/projects/{{pid}}/milestones/{{mid}}';
Routes.info['api:diagrams']       = '/api/projects/{{pid}}/diagrams';
Routes.info['api:diagram-directories']       = '/api/projects/{{pid}}/diagram-directories';
Routes.info['api:diagram:events'] = '/api/projects/{{pid}}/diagrams/{{did}}/events';
Routes.info['api:tags']           = '/api/projects/{{pid}}/tags';
Routes.info['api:tag-categories'] = '/api/projects/{{pid}}/tag-categories';
Routes.info['api:diagram']        = '/api/projects/{{pid}}/diagrams/{{did}}';
Routes.info['api:comments']       = '/api/projects/{{pid}}/diagrams/{{did}}/comments';
Routes.info['api:elements']       = '/api/projects/{{pid}}/diagrams/{{did}}/elements';
Routes.info['api:valueTypes']       = '/api/projects/{{pid}}/value-types';
Routes.info['api:rlinks']         = '/api/projects/{{pid}}/diagrams/{{did}}/remote-links';
Routes.info['api:record']         = '/api/projects/{{pid}}/records/{{eid}}';
Routes.info['api:relation']       = '/api/projects/{{pid}}/relations/{{eid}}';
Routes.info['api:project:search'] = '/api/projects/{{pid}}/search';
Routes.info['api:viewers:diagram']      = '/api/projects/{{pid}}/diagrams/{{did}}/viewers';
Routes.info['api:viewers:action']       = '/api/projects/{{pid}}/actions/{{aid}}/viewers';
Routes.info['api:channel:diagram']= '/api/channel/projects/{{pid}}/diagrams/{{did}}';
Routes.info['api:channel:ping']   = '/api/channel/ping/{{clientId}}/{{pingId}}';

Routes.info['api:report']         = '/api/report';

// Dashboard画面内の Backbone.Router が使用する Hashパス の定義
Routes.info['dashboard:root']          = '#';
Routes.info['dashboard:group']         = '#/groups/{{gid}}';
Routes.info['dashboard:group/edit']    = '#/groups/{{gid}}/edit';
Routes.info['dashboard:project']       = '#/projects/{{pid}}';

// Diagram画面内の Backbone.Router が使用する Hash パスの定義
Routes.info['diagram:element']        = '#/elements/{{id}}';

// 要望詳細画面
Routes.info['feedback']        = 'feedbacks/{{rid}}';
Routes.info['hash:comment']        = '#/comments/{{comment_id}}';

// 画面URIのパス定義
Routes.info['path:dashboard']     = '/';
Routes.info['path:group']         = '/groups/{{gid}}';
Routes.info['path:project']       = '/projects/{{pid}}';
Routes.info['path:diagram']       = '/projects/{{pid}}/diagrams/{{did}}';
Routes.info['path:action']        = '/projects/{{pid}}/processes/{{id}}';
Routes.info['path:action:comment'] = '/projects/{{pid}}/processes/{{aid}}#/comments/{{comment_id}}';
Routes.info['path:comment']       = '/projects/{{pid}}/diagrams/{{did}}#/comments/{{comment_id}}';
Routes.info['path:feedback']      = '/feedbacks/{{rid}}';
Routes.info['path:blob']          = '/blobs/{{blob_id}}';
Routes.info['path:diff']          = '/projects/{{pid}}/diagrams/{{did}}/diff';

// TODO: Compatibility (should remove)
_.each(Routes.info, function(v, k) {
    if (k.indexOf('api:') == 0) {
        Routes.info[k.replace('api:', '')] = v;
    }
});

Routes.alias['gid'] = ['group_id', 'groupId'];
Routes.alias['uid'] = ['user_id', 'member_id', 'userId', 'memberId'];
Routes.alias['pid'] = ['project_id', 'projectId'];
Routes.alias['did'] = ['diagram_id', 'diagramId'];
Routes.alias['eid'] = ['element_id', 'elementId'];
Routes.alias['mid'] = ['milestone_id'];
Routes.alias['tid'] = ['task_id'];
Routes.alias['aid'] = ['actionId'];

Routes._parse_path = function(path) {
    var ret = path.match(/\{\{[A-Za-z_]+\}\}/g);
    ret = _.map(ret, function(str) {
        return str.replace('{{', '').replace('}}', '');
    });
    return ret;
};

Routes._args_check = function(param_names, args) {
    var ret = {};
    if ((!param_names) || (!args)) {
        return ret;
    }
    _.each(param_names, function(name) {
        if (args[name]) {
            ret[name] = args[name];
        } else if (Routes.alias[name]) {
            // Routes.alias に key が見つかれば、他の alias name で値が存在するかチェックする
            var n = _.find(Routes.alias[name], function(n) { return args[n]; });
            ret[name] = args[n];
        }
    });
    return ret;
};

Routes.urlFor = function(key, params, queryParams) {
    var path = Routes.info[key];
    if (path) {
        var param_names = Routes._parse_path(path);
        var args = Routes._args_check(param_names, params);
        var url = path;
        _.each(args, function(v, k) {
            if (k && v) {
                url = url.replace('{{' + k + '}}', v);
            }
        });
        var ret = url.match(/\{\{[A-Za-z]+\}\}/g);
        if (ret && ret.length > 0) {
            // LogLevel.error("not replaced variables:: {{URL}}".replace('{{URL}}', url));
            throw new Error("ArgumentError (too few arguments)");
        }

        if (queryParams) {
            var queryParamsString = _.chain(queryParams)
                .map(function(v, k) {
                    if (v) {
                        return k + '=' + encodeURIComponent(v);
                    }
                }).compact().join('&');

            if (url.indexOf('?') > 0) {
                url += '&' + queryParamsString;
            } else {
                url += '?' + queryParamsString;
            }
        }

        return url;
    } else {
        throw new Error("NotFoundError (URL not found; key: {{KEY}})".replace('{{KEY}}', key));
    }
};

Routes.parse = function(path, pattern) {
    // 初期状態: pattern -> '/groups/{{gid}}
    var keys = [];

    // {{gid}} となっている部分を (\w+) にリプレースしつつ
    // gid を抜き出す
    // 変換後: pattern -> '/groups/(\w+)'
    pattern = pattern.replace(/\{\{\w+\}\}/g, function(m) {
        keys.push(m.substring(2, m.length - 2));
        return '(\\w+)';
    });

    // / を \/ にエスケープする
    // 変換後: pattern -> '\/groups\/(\w+)'
    pattern = pattern.replace(/\//g, '\\/');

    var re = new RegExp(pattern);
    var m = re.exec(path);
    if(!m) {
        return null;
    }
    m.shift();

    var matched = {};
    _.each(m, function(v, i) {
        matched[keys[i]] = v;
    });

    return matched;
};

module.exports = Routes;



// WEBPACK FOOTER //
// ./common/route.js